<template>
  <el-empty :image="getImage" :image-size="getImageSize" :description="description">
    <slot name="content"></slot>
  </el-empty>
</template>

<script>
import classEmptyImage from '../../styles/empty/images/empty-add-class.svg';
import networkEmptyImage from '../../styles/empty/images/empty-network.svg';
import dataEmptyImage from '../../styles/empty/images/empty-data.svg';
import searchEmptyImage from '../../styles/empty/images/empty-search.svg';
import transingEmptyImage from '../../styles/empty/images/empty-transing.svg';
export default {
  name: 'EmptyIndex',
  components: {
  },
  props: {
    emptyType: {
      type: String,
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    getImage(){
      let imageUrl = dataEmptyImage;
      switch (this.emptyType){
        case 'add-class':
          imageUrl = classEmptyImage;
          break;
        case 'network':
          imageUrl = networkEmptyImage;
          break;
        case 'data':
          imageUrl = dataEmptyImage;
          break;
        case 'search':
          imageUrl = searchEmptyImage;
          break;
        case 'transing':
          imageUrl = transingEmptyImage;
          break;
      }
      return imageUrl;
    },
    getImageSize(){
      let imageSize = 130;
      switch (this.emptyType){
        case 'transing':
          imageSize = 206;
          break;
      }
      return imageSize;
    },
  }
};
</script>
<style lang="scss">
.el-empty__image {
  margin: 0 auto;
}
.el-empty__description{
  color: #909599;
  font-size: 14px;
  margin-top: 16px;
}
</style>
